module.exports = __webpack_public_path__ + "img/bird-13-right.445bfccd.png";